import { QueryFunctionContext } from '@tanstack/react-query';
import { ForumUserDataType } from 'src/query/types';

import { forumApiRequest } from './common';

export async function forumGetUserProfile(userSlug: string, params: QueryFunctionContext) {
  const res = await forumApiRequest.get(`/user/${userSlug}`, params);
  return res.data as ForumUserDataType;
}
